import _, {interpolate} from 'topmeteo/utils/i18n';

import TranslatedLink from './TranslatedLink';

const Message = _('Successfully exported task <a>%(name)s</a> to WeGlide.');

const WeGlideSuccessNotification = ({id, name}) => {
    const message = interpolate(Message, {name});
    const href = `https://www.weglide.org/task/${id}`;

    return <TranslatedLink className="weglide" Element="span" message={message} href={href} />;
};

export default WeGlideSuccessNotification;
